var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 0.422852C7.59977 0.422852 0.922852 7.09977 0.922852 15.4998C0.922852 23.8998 7.59977 30.5767 15.9998 30.5767C24.3998 30.5767 31.0767 23.8998 31.0767 15.4998C31.0767 7.09977 24.3998 0.422852 15.9998 0.422852ZM9.53824 26.6998V23.469C9.53824 21.5305 10.8305 20.0229 12.769 19.8075H19.2305C21.169 20.0229 22.4613 21.5305 22.4613 23.469V26.6998C18.369 29.069 13.6305 29.069 9.53824 26.6998ZM24.6152 24.1152V22.3921C24.6152 20.4536 22.2459 17.869 19.2305 17.6536H12.769C9.75362 17.869 7.38439 20.4536 7.38439 23.469V24.5459V25.1921C1.99977 20.4536 1.56901 12.269 6.30747 6.88439C11.0459 1.49977 19.2305 1.06901 24.6152 5.80747C29.9998 10.5459 30.4305 18.7305 25.6921 24.1152C25.4767 24.5459 25.0459 24.7613 24.6152 25.1921V24.1152Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 4.73047C12.9845 4.73047 10.6152 7.0997 10.6152 10.1151C10.6152 13.1305 12.9845 15.4997 15.9999 15.4997C19.0152 15.4997 21.3845 13.1305 21.3845 10.1151C21.3845 7.0997 19.0152 4.73047 15.9999 4.73047ZM15.9999 13.3459C14.2768 13.3459 12.7691 11.8382 12.7691 10.1151C12.7691 8.39201 14.2768 6.88432 15.9999 6.88432C17.7229 6.88432 19.2306 8.39201 19.2306 10.1151C19.2306 11.8382 17.7229 13.3459 15.9999 13.3459Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatar);
export default __webpack_public_path__ + "static/media/EmptyAvatar.f826aeaa796b14435c527ed373d58648.svg";
export { ForwardRef as ReactComponent };